import { Action as ReduxAction, Dispatch } from 'redux';
import { FontType } from '../../drawing/types';
import { TextboxType } from '../../reducers/ui/textbox';
import { Color } from '../../types/color';

namespace TextboxUIAction {
  export enum ActionType {
    SELECT_TOOL = 'UI_TEXTBOX_SELECT_TOOL',
    SET_FILL_COLOR = 'UI_TEXTBOX_SET_FILL_COLOR',
    SET_LINE_COLOR = 'UI_TEXTBOX_SET_LINE_COLOR',
    SET_FONT_TYPE = 'UI_TEXTBOX_SET_FONT_TYPE',
    SET_FONT_SIZE = 'UI_TEXTBOX_SET_FONT_SIZE',
    SET_LINE_HEIGHT = 'UI_TEXTBOX_SET_LINE_HEIGHT',
    SET_PADDING = 'UI_TEXTBOX_SET_PADDING',
    SET_TEXT_COLOR = 'UI_TEXTBOX_SET_TEXT_COLOR',
    SET_TOOL_TYPE = 'UI_TEXTBOX_SET_TOOL_TYPE',
  }

  interface SelectTextboxToolAction extends ReduxAction {
    type: typeof ActionType.SELECT_TOOL;
    selected: number;
  }

  interface SetTextboxFillColorAction extends ReduxAction {
    type: typeof ActionType.SET_FILL_COLOR;
    selected: number;
    fillColor: Color;
  }

  interface SetTextboxLineColorAction extends ReduxAction {
    type: typeof ActionType.SET_LINE_COLOR;
    selected: number;
    lineColor: Color;
  }

  interface SetTextboxFontTypeAction extends ReduxAction {
    type: typeof ActionType.SET_FONT_TYPE;
    selected: number;
    fontType: FontType;
  }

  interface SetTextboxFontSizeAction extends ReduxAction {
    type: typeof ActionType.SET_FONT_SIZE;
    selected: number;
    fontSize: number;
  }

  interface SetTextboxLineHeightAction extends ReduxAction {
    type: typeof ActionType.SET_LINE_HEIGHT;
    selected: number;
    lineHeight: number;
  }

  interface SetTextboxPaddingAction extends ReduxAction {
    type: typeof ActionType.SET_PADDING;
    selected: number;
    padding: number;
  }

  interface SetTextboxTextColorAction extends ReduxAction {
    type: typeof ActionType.SET_TEXT_COLOR;
    selected: number;
    textColor: Color;
  }

  interface SetTextboxTypeAction extends ReduxAction {
    type: typeof ActionType.SET_TOOL_TYPE;
    selected: number;
    textboxType: TextboxType;
  }

  export type Action =
    SelectTextboxToolAction
    | SetTextboxFillColorAction
    | SetTextboxLineColorAction
    | SetTextboxFontTypeAction
    | SetTextboxFontSizeAction
    | SetTextboxLineHeightAction
    | SetTextboxPaddingAction
    | SetTextboxTextColorAction
    | SetTextboxTypeAction;

  export function isDomesticAction(action: ReduxAction): action is Action {
    return Object.keys(ActionType).some(k => action.type === ActionType[k as any]);
  }

  export function selectTextboxTool(selected: number, dispatch: Dispatch<ReduxAction>) {
    dispatch({ selected, type: ActionType.SELECT_TOOL });
  }

  export function setTextboxFillColor(
    selected: number,
    fillColor: Color,
    dispatch: Dispatch<ReduxAction>,
  ) {
    dispatch({ selected, fillColor, type: ActionType.SET_FILL_COLOR });
  }

  export function setTextboxLineColor(
    selected: number,
    lineColor: Color,
    dispatch: Dispatch<ReduxAction>,
  ) {
    dispatch({ selected, lineColor, type: ActionType.SET_LINE_COLOR });
  }

  export function setTextboxFontType(
    selected: number,
    fontType: FontType,
    dispatch: Dispatch<ReduxAction>,
  ) {
    dispatch({ selected, fontType, type: ActionType.SET_FONT_TYPE });
  }

  export function setTextboxFontSize(
    selected: number,
    fontSize: number,
    dispatch: Dispatch<ReduxAction>,
  ) {
    dispatch({ selected, fontSize, type: ActionType.SET_FONT_SIZE });
  }

  export function setTextboxLineHeight(
    selected: number,
    lineHeight: number,
    dispatch: Dispatch<ReduxAction>,
  ) {
    dispatch({ selected, lineHeight, type: ActionType.SET_LINE_HEIGHT });
  }

  export function setTextboxPadding(
    selected: number,
    padding: number,
    dispatch: Dispatch<ReduxAction>,
  ) {
    dispatch({ selected, padding, type: ActionType.SET_PADDING });
  }

  export function setTextboxTextColor(
    selected: number,
    textColor: Color,
    dispatch: Dispatch<ReduxAction>,
  ) {
    dispatch({ selected, textColor, type: ActionType.SET_TEXT_COLOR });
  }

  export function setTextboxType(
    selected: number,
    textboxType: TextboxType,
    dispatch: Dispatch<ReduxAction>,
  ) {
    dispatch({ selected, textboxType, type: ActionType.SET_TOOL_TYPE });
  }
}

export default TextboxUIAction;
